import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FaCaretDown } from 'react-icons/fa';
import AnimatedAccordion from 'products/nomad_insurance/components/AnimatedAccordion';
import { AccordionHeading } from './styled';

const Accordion = ({ heading, children, childrenMarginTop }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <AccordionHeading onClick={() => setIsOpen(!isOpen)} $isOpen={isOpen}>
        {heading} <FaCaretDown />
      </AccordionHeading>
      <AnimatedAccordion isOpen={isOpen} marginTop={childrenMarginTop || '16px'}>
        {children}
      </AnimatedAccordion>
    </>
  );
};

Accordion.propTypes = {
  heading: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  childrenMarginTop: PropTypes.string
};

export default Accordion;
